import loadable from '@loadable/component';

export const OrgDashboardBuyCreditPacksContainerLoadable = loadable(
  () => import('./OrgDashboardBuyCreditPacksContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardBuyCreditPacksContainer,
    ssr: false,
  },
);
